(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("dashboardKarcherActions", dashboardKarcherActionsFactory);

  /** @ngInject */
  function dashboardKarcherActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum
  ) {
    return {
      getKarcherSitesData: getKarcherSitesData,
      getKarcherSitesInfoWindowData: getKarcherSitesInfoWindowData,
      getKarcherSiteDetailsById: getKarcherSiteDetailsById,
      getKarcherSiteAlarmList: getKarcherSiteAlarmList,
      getKarcherAlarmsHistoryList: getKarcherAlarmsHistoryList,
      getKarcherDeviceDetailsById: getKarcherDeviceDetailsById,
      getKarcherFaultsByDeviceId: getKarcherFaultsByDeviceId,
      getEventsListForSelectedDevice: getEventsListForSelectedDevice,
      getRolloverPrograms: getRolloverPrograms,
      getRolloverProgramsBySite: getRolloverProgramsBySite,
      getRolloverProgramOptions: getRolloverProgramOptions,
      getRolloverVouchersBySite: getRolloverVouchersBySite,
      getRolloverVoucherRedeems: getRolloverVoucherRedeems,
      getRolloverSalesTypes: getRolloverSalesTypes,
      getAllRolloverSalesTypes: getAllRolloverSalesTypes,
      updateRolloverSalesType: updateRolloverSalesType,
      createRolloverVoucher: createRolloverVoucher,
      deactivateRolloverVoucher: deactivateRolloverVoucher
    };

    function getKarcherSitesData(siteName, alarmStatus) {
      var deferred = $q.defer();
      api.getKarcherSitesData(siteName, alarmStatus).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSitesInfoWindowData(siteId) {
      var deferred = $q.defer();
      api.getKarcherSitesInfoWindowData(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSiteDetailsById(siteId) {
      var deferred = $q.defer();
      api.getKarcherSiteDetailsById(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherFaultsByDeviceId(deviceId) {
      var deferred = $q.defer();
      api.getKarcherFaultsByDeviceId(deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSiteAlarmList(
      filter,
      faultStatus,
      facilityId,
      siteId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getKarcherSiteAlarmList(
          filter,
          faultStatus,
          facilityId,
          siteId,
          from,
          to,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getKarcherAlarmsHistoryList(
      filter,
      facilityId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getKarcherAlarmsHistoryList(
          filter,
          facilityId,
          from,
          to,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getKarcherDeviceDetailsById(siteId, deviceId) {
      var deferred = $q.defer();
      api.getKarcherDeviceDetailsById(siteId, deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getEventsListForSelectedDevice(deviceKey) {
      var deferred = $q.defer();
      api.getEventsListForSelectedDevice(deviceKey).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverPrograms(washFacilityId) {
      var deferred = $q.defer();
      api.getRolloverPrograms(washFacilityId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverProgramsBySite(siteId) {
      var deferred = $q.defer();
      api.getRolloverProgramsBySite(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getRolloverProgramOptions(deviceId, programId) {
      var deferred = $q.defer();
      api.getRolloverProgramOptions(deviceId, programId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverVouchersBySite(siteId, page, pageSize, search) {
      var deferred = $q.defer();
      api.getRolloverVouchersBySite(siteId, page, pageSize, search).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getRolloverVoucherRedeems(voucherId) {
      var deferred = $q.defer();
      api.getRolloverVoucherRedeems(voucherId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getRolloverSalesTypes() {
      var deferred = $q.defer();
      api.getRolloverSalesTypes().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getAllRolloverSalesTypes() {
      var deferred = $q.defer();
      api.getAllRolloverSalesTypes().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateRolloverSalesType(salesTypeData) {
      var deferred = $q.defer();
      api.updateRolloverSalesType(salesTypeData).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function createRolloverVoucher(voucherData) {
      var deferred = $q.defer();
      api.createRolloverVoucher(voucherData).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deactivateRolloverVoucher(voucherId) {
      var deferred = $q.defer();
      api.deactivateRolloverVoucher(voucherId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

  }
})();
